<template>
  <div
    :ref="(el) => onRefMounted(el)"
    class="tabs-wrapper"
    :class="{ 'tabs-wrapper-center': center }"
  >
    <div
      v-for="(item, index) in tabs"
      :key="index"
      :value="item.value"
      class="tab-item"
      :class="{ 'tab-item-active': value ? value === item.value : activeKey === item.value }"
      :style="index === tabs.length - 1 ? 'margin-right: 0; margin-left: 0' : ''"
      @click="e => onChangeTab(item, e)"
    >
      {{ item.name }}
    </div>
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue'
interface TabItem {
  value: number | string
  name: string
}
export default defineComponent({
  props: {
    tabs: {
      require: true,
      default: () => ([] as TabItem[])
    },
    value: {
      default: ''
    },
    defaultKey: {
      type: [String, Number],
      default: null
    },
    center: {
      default: false
    }
  },
  emits: ['change'],
  setup (props, ctx) {
    const activeKey = ref(props.defaultKey || props.tabs[0]?.value)
    const itemRefs = ref([])
    const tabWrapperRef = ref()
    const onChangeTab = (tab: TabItem, e: Event) => {
      activeKey.value = tab.value
      // 抛出event方便外部埋点
      const result = {
        ...tab,
        e
      }
      ctx.emit('change', result)
    }
    onMounted(() => console.log(itemRefs.value))
    watch(() => props.value, (newVal) => {
      activeKey.value = newVal
    })
    watch(() => activeKey.value, (newVal) => {
      const itemIndex = props.tabs.findIndex(i => i.value === newVal)
      if (!tabWrapperRef.value || itemIndex === -1) return
      const children = tabWrapperRef.value.children
      if (children[itemIndex]) {
        tabWrapperRef.value.scrollTo({
          left: children[itemIndex].offsetLeft - 10,
          behavior: 'smooth'
        })
      }
    })
    return {
      activeKey,
      onChangeTab,
      onRefMounted: (el: any) => {
        tabWrapperRef.value = el
      }
    }
  }
})
</script>

<style scoped lang="less">
.tabs-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  overflow-x: scroll;
  position: relative;
  // hide scroll-bar in firefox
  scrollbar-color: transparent transparent;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  .tab-item {
    font-weight: 600;
    color: #333;
    font-size: 16px;
    padding: 22px 0;
    margin-right: 80px;
    cursor: pointer;
    white-space: nowrap;
  }
  .tab-item-active {
    color: @theme-color;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 3px;
      background: @theme-color;
      bottom: 0;
      left: 0;
    }
  }
}

.tabs-wrapper-center {
  justify-content: center;
}

.rtl--container {
  .tab-item {
    margin-right: 0;
    margin-left: 80px;
  }
}

@media only screen and (max-width: 992px) {
  .tabs-wrapper {
    .tab-item {
      font-size: 1.6rem;
      padding: 1.5rem 0;
      margin-right: 3rem;
      font-weight: 600;
    }
  }
  .rtl--container {
    .tabs-wrapper {
      .tab-item {
        margin-right: 0;
        margin-left: 3rem;
      }
    }
  }
}
</style>
